const p=({breakpoints:o,spacing:d})=>({styleOverrides:{root:{padding:d(3),paddingTop:d(3),paddingBottom:d(3),[o.down("sm")]:{padding:d(2),paddingTop:d(2),paddingBottom:d(2),"&:last-of-type":{paddingBottom:d(2)}}}}});export{p as default};
